import { render, staticRenderFns } from "./senders.vue?vue&type=template&id=f57cfdcc&"
import script from "./senders.vue?vue&type=script&lang=js&"
export * from "./senders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports